module.exports = __webpack_public_path__ + "img/woman-body-back.4d0d6b18.png";